'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mobx = require('mobx');

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var graphql = function graphql(config) {
  var client = config.client,
      onError = config.onError,
      onFetch = config.onFetch,
      opts = _objectWithoutProperties(config, ['client', 'onError', 'onFetch']);

  var query = client.watchQuery(opts);

  var observableQuery = (0, _mobx.observable)(query.currentResult());

  query.subscribe({
    next: (0, _mobx.action)(function (value) {
      observableQuery.error = undefined;
      observableQuery.loading = value.loading;
      observableQuery.data = value.data;

      if (onFetch) onFetch(value.data);
    }),
    error: (0, _mobx.action)(function (error) {
      observableQuery.error = error;
      observableQuery.loading = false;
      observableQuery.data = undefined;

      if (onError) onError(error);
    })
  });

  observableQuery.ref = query;

  return observableQuery;
};

exports.default = graphql;
